import React, { useEffect, useRef } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import DateFormat from "../../common/dateFormat/DateFormat";

const estiloBotao = (desabilitado) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.5rem",
    fontWeight: 500,
    boxShadow: desabilitado ? "inset 0 0 16px 1px #ccc" : "0 0 10px 1px #ccc",
    color: "#0070cc",
    width: 40,
    height: 40,
    borderRadius: "100%",
    backgroundColor: "#fff",
    border: "none",
    marginInline: 20,
});

const estiloInputData = { fontSize: "1.2rem", padding: 7, border: "1px solid #999", borderRadius: 10 };

function InputData({ value, min, max, disabled, onCommit }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const confirmar = (evento) => onCommit(evento.target.value);
        el.addEventListener("change", confirmar);
        return () => el.removeEventListener("change", confirmar);
    }, [onCommit]);

    useEffect(() => {
        if (ref.current && ref.current.value !== value) {
            ref.current.value = value || "";
        }
    }, [value]);

    return <input ref={ref} style={estiloInputData} required type="date" disabled={disabled} defaultValue={value} min={min || undefined} max={max || undefined} />;
}

export default function FiltroGraficoDia({ dataInicialGrafico, dataFinalGrafico, setDataInicialGrafico, setDataFinalGrafico, aguardando, mensagem }) {
    const mudarData = (data, dias, setData) => {
        const novaData = new Date(data);
        novaData.setUTCDate(novaData.getUTCDate() + dias);
        setData(novaData.toISOString().substring(0, 10));
    };
    const hoje = DateFormat.getDataAtual().replace(/\//g, "-");
    return (
        <Row style={{ width: "100%", justifyContent: "center" }}>
            <Grid cols="12 12 12 12" style={{ textAlign: "center", color: "#d42243" }}>
                {mensagem}
            </Grid>
            <Grid cols="12 12 4 4" style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center" }}>
                <button style={estiloBotao(false)} disabled={aguardando} onClick={() => mudarData(dataInicialGrafico, -1, setDataInicialGrafico)}>
                    &lt;
                </button>
                <InputData
                    value={dataInicialGrafico}
                    max={dataFinalGrafico}
                    disabled={aguardando}
                    onCommit={(data) => setDataInicialGrafico(data || dataFinalGrafico)}
                />
                <button
                    style={estiloBotao(dataInicialGrafico === dataFinalGrafico)}
                    disabled={dataInicialGrafico === dataFinalGrafico || aguardando}
                    onClick={() => mudarData(dataInicialGrafico, 1, setDataInicialGrafico)}
                >
                    &gt;
                </button>
            </Grid>
            <div style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center", fontSize: "1.2rem", padding: 15 }}>Até</div>
            <Grid cols="12 12 4 4" style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center" }}>
                <button
                    style={estiloBotao(dataInicialGrafico === dataFinalGrafico)}
                    disabled={dataInicialGrafico === dataFinalGrafico || aguardando}
                    onClick={() => mudarData(dataFinalGrafico, -1, setDataFinalGrafico)}
                >
                    &lt;
                </button>
                <InputData
                    value={dataFinalGrafico}
                    min={dataInicialGrafico}
                    max={hoje}
                    disabled={aguardando}
                    onCommit={(data) => setDataFinalGrafico(data || hoje)}
                />
                <button
                    style={estiloBotao(dataFinalGrafico === hoje)}
                    disabled={dataFinalGrafico === hoje || aguardando}
                    onClick={() => mudarData(dataFinalGrafico, 1, setDataFinalGrafico)}
                >
                    &gt;
                </button>
            </Grid>
        </Row>
    );
}
